// Typelizer digest f2d47c6bb803179d1e5e956baa78445b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /api/v1/productions/:production_id/run */
  show: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/api/v1/productions/:production_id/run', params, options),
    method: 'get',
  }),
}
